const CATEGORY_ORDER = ['CRM', 'Website', 'Mobile', 'Server', 'Database & Data warehouse', 'API'];

const REVERSE_ETL_CATEGORY_ORDER = ['Database & Data warehouse', 'CRM', 'Website', 'Mobile', 'Server', 'API'];

function sorter(order: string[], a: string, b: string) {
  let aIndex = order.indexOf(a);
  let bIndex = order.indexOf(b);

  // Unrecognized categories should be sorted to the end.
  if (aIndex === -1) {
    aIndex = order.length;
  }
  if (bIndex === -1) {
    bIndex = order.length;
  }

  // Sort by category order.
  return aIndex - bIndex;
}

export function sourceCategorySorter(a: string, b: string) {
  return sorter(CATEGORY_ORDER, a, b);
}

export function reverseETLSourceCategorySorter(a: string, b: string) {
  return sorter(REVERSE_ETL_CATEGORY_ORDER, a, b);
}
